// extracted by mini-css-extract-plugin
module.exports = {"title-row":"TeamRubricComponent_title-row__2ni01","title":"TeamRubricComponent_title__1YBhH","weight-scheme":"TeamRubricComponent_weight-scheme__2_GfJ"};